export default {
  feedback: {
    usage_threshold: 'Mindestbestellwert für diese Promo beträgt (abz. Lieferkosten & Trinkgeld)',
    promo_code_added: 'Promo Code erfolgreich angewandt',
  },
};
